import { PropsWithChildren, ReactNode } from 'react'
import { Card, CardHeader, CardContent, CardActions, Box, SxProps, Theme } from '@mui/material'
import { Progress } from '~/components/progress/Progress'

export type Props = {
  title?: ReactNode
  subTitle?: ReactNode
  className?: string
  dataLoading?: boolean
  onlyRenderChildrenOnMobile?: boolean
  actions?: ReactNode
  sx?: SxProps<Theme>
}

export const CardFormTitle = ({ children }: { children: React.ReactNode }) => (
  <span className="md-subheading-2" style={{ fontWeight: 'bold' }}>
    {children}
  </span>
)

export const CardForm = ({
  className = '',
  title = null,
  subTitle = null,
  children,
  dataLoading = false,
  actions = null,
  onlyRenderChildrenOnMobile = false,
  sx,
}: PropsWithChildren<Props>) => (
  <>
    {onlyRenderChildrenOnMobile && <Box sx={{ display: { sm: 'none', xs: 'block' } }}>{children}</Box>}

    <Box sx={[{ display: onlyRenderChildrenOnMobile ? { xs: 'none', sm: 'block' } : {} }, sx] as SxProps<Theme>}>
      <Card className={className}>
        {title && (
          <CardHeader title={typeof title === 'string' ? <CardFormTitle>{title}</CardFormTitle> : title || ''} />
        )}

        {subTitle && <span key="subtitle">{subTitle}</span>}

        {children && (
          <CardContent>
            <div style={{ visibility: dataLoading ? 'hidden' : 'visible' }}>{children}</div>

            {dataLoading && <Progress />}
          </CardContent>
        )}

        {actions && (
          <CardActions key="cardActions" style={{ justifyContent: 'flex-end', flexDirection: 'column-reverse' }}>
            {actions}
          </CardActions>
        )}
      </Card>
    </Box>
  </>
)
